// extracted by mini-css-extract-plugin
module.exports = {"layout":"A4_65_Labels_38mm_x_21mm_layout__3WmX9"};